var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export var DataDogScript = function (_a) {
    var config = _a.config, enrolRum = _a.enrolRum;
    var defaultConfig = {
        clientToken: config.clientToken,
        site: config.site,
        service: config.service,
        env: config.env,
        version: config.version,
    };
    // https://docs.datadoghq.com/logs/log_collection/javascript/#cdn-async
    var loggerScriptInnerHTML = !!config.logs &&
        "\n  (function(h,o,u,n,d) {\n    h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}\n    d=o.createElement(u);d.async=1;d.src=n\n    n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)\n  })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v4/datadog-logs.js','DD_LOGS')\n    DD_LOGS.onReady(function() {\n      DD_LOGS.init(".concat(JSON.stringify(__assign(__assign(__assign({}, defaultConfig), { 
            // Do not automatically send logs. The logger will send to DD for us.
            forwardErrorsToLogs: false }), config.logs)), ")\n    });");
    // https://docs.datadoghq.com/real_user_monitoring/browser/#cdn-async
    var rumScriptInnerHTML = enrolRum &&
        !!config.rum &&
        "\n  (function(h,o,u,n,d) {\n     h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}\n     d=o.createElement(u);d.async=1;d.src=n\n     n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)\n  })(window,document,'script','https://www.datadoghq-browser-agent.com/datadog-rum-v4.js','DD_RUM')\n    DD_RUM.onReady(function() {\n      DD_RUM.init(".concat(JSON.stringify(__assign(__assign({}, defaultConfig), { sessionSampleRate: 100, applicationId: config.rum.applicationId, defaultPrivacyLevel: config.rum.defaultPrivacyLevel, trackInteractions: config.rum.trackInteractions, enableExperimentalFeatures: config.rum.enableExperimentalFeatures })), ")\n    });");
    return (React.createElement("script", { 
        // biome-ignore lint/security/noDangerouslySetInnerHtml: noDangerouslySetInnerHtml
        dangerouslySetInnerHTML: {
            __html: [loggerScriptInnerHTML, rumScriptInnerHTML]
                .filter(Boolean)
                .join('\n'),
        } }));
};
